import { h, Component, Fragment } from 'preact';
import {Button, I18n, Form, Container, Tile} from 'components/elements' 
import {PatientSelectCard} from 'components/groups'
import {times} from 'lib/helpers'
import {connect} from 'react-redux'
import style from './style.less'
import dayjs from 'lib/helpers/dayjs';
import { PatientActions } from 'actions';

@Form
@connect((state)=>({
	...state
}))
export default class PatientSelectVertical extends Component {
	constructor(){
        super()
        this.state = {
            newPatient: ''
        }
        this.handleNewPatient = this.handleNewPatient.bind(this)
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
        this.handleNewPatientSubmit = this.handleNewPatientSubmit.bind(this)
        this.handleNewPatientCancel = this.handleNewPatientCancel.bind(this)
    }
    
    get newPatientCount(){
        let newPatientCount = this.patients.filter((patient)=>/newPatient/.test(patient.id)).length
        return newPatientCount
    }

    get patients(){
        return Object.values(this.props.patients || {})
    }

    get patientsReversed() {
        const value = [...this.patients]
        value.reverse()
        return value
    }
    
    get appointmentTypes(){
        return Object.values(this.props.appointmentTypes || {}).filter((appType)=>{
            if(appType.userType && ((!(this.props.session || {}).accessToken && appType.userType == 'returning') || ((this.props.session || {}).accessToken && appType.userType == 'new'))){
                return false
            }
            let maxPatients = 1
            if(appType.durations){
                maxPatients = appType.durations.split(',').length 
            }
            if(!this.props.filters.patientCount || this.props.filters.patientCount <= maxPatients){
                return true
            }
            return false
        })
    }

    get appointmentType(){
        return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
    }

    get hasRestrictions(){
        return (this.appointmentType.rules || []).length > 0
    }
    
    get classifications(){
        const classifications = Object.entries(this.props.classifications || {})
            .map(([, _])=> _ )
            .filter((c)=>(_.isNil(c.siblingID) && c.active))
		
		return classifications.map((_)=>({
            name: _.name,
			value: _.id
		}))
    }

    get genders(){
		return Object.values(this.props.genders || {}).map((_)=>({
            name: _.name,
			value: _.id
		}))
    }

    get weightUnit(){
        switch(this.organization.country){
            case "US":
                return I18n.t('lbs')
            case "CA":
                return I18n.t('kg')
            default:
                return I18n.t('lbs')
        }
    }

    get organization(){
        return this.props.organization || {}
    }


    handleNewPatient(e){
        e.preventDefault()
        this.setState({
            newPatient: {}
        })
    }

    handleNewPatientCancel(e){
        e.preventDefault()
        this.setState({
            newPatient: ''
        })
    }

    handleNewPatientSubmit(values){
        let day =  dayjs() 
        const ageYears = values.ageYears
        if(ageYears != undefined){
            day = day.subtract(ageYears, 'year')
            delete values.ageYears
        }
        const ageMonths = values.ageMonths
        if(ageMonths != undefined){
            day = day.subtract(ageMonths, 'month')
            delete values.ageMonths
        }
        if(ageMonths != undefined || ageYears != undefined){
            values.birthday = day
        }

        this.setState({
            newPatient: ''
        })
        let patient = {
            ...values,
            id: `newPatient-${values.name.replace(/ /g, '-')}`,
            firstName: values.name
        }
        this.props.Form.reset()
        PatientActions.append(patient)

        this.handlePatientSelect(patient)
    }

    handlePatientSelect(patient){
        this.setState({})
        this.props.onPatientSelect && this.props.onPatientSelect(patient)
    }

    get patientsToCreate(){
        let numNewPets = this.patients.length
        let count = this.props.filters.patientCount - numNewPets
        if(count <= 0 && this.state.newPatient){
            count = 1
        }
        return count
    }

	render(){
        const {Form, InputDark, SelectDark, FormData} = this.props

		return (
            <Container title='Patients' class={style.patientSelectorContainer}>
                {this.patientsReversed.map((patient, i)=>{
                    const selected = Object.keys(this.props.selectedPatients).indexOf(patient.id) != -1
                    return (
                        <Tile selected={!!selected} >
                            <PatientSelectCard 
                                {...patient}
                                selected={!!selected}
                                onSelect={this.handlePatientSelect.bind(null, patient)} 
                            />
                        </Tile>
                    )
                })}
                {(this.patientsToCreate > 0) ?(
                    <Tile class={style.newPatientFormContainer}>
                        <div key={`new-patient-container-${this.newPatientCount}`} >
                            <Form onSubmit={this.handleNewPatientSubmit}>
                                <div className={style.rowItem}>
                                    <div className={style.singleItem}>
                                        {this.hasRestrictions &&  <label><I18n>name</I18n></label>}
                                        <InputDark 
                                            required={true} 
                                            name='name' 
                                            type='text' 
                                            question={I18n.t("name")}
                                            initialValue={''}
                                        />
                                    </div>
                                </div>
                                {this.hasRestrictions && (
                                    <div className={style.rowItem}>
                                        <div className={style.item}>
                                            <label><I18n>years</I18n></label>
                                            <InputDark 
                                                required={true}
                                                id='ageYears'
                                                name='ageYears'
                                                type='number'
                                                min="0"
                                                question={I18n.t("ageYears")}
                                                initialValue={''}
                                            />
                                         </div>
                                         <div className={style.item}>
                                            <label><I18n>months</I18n></label>
                                            <InputDark 
                                                required={true}
                                                id='ageMonths'
                                                name='ageMonths'
                                                type='number'
                                                min="0"
                                                question={I18n.t("ageMonths")}
                                                initialValue={''}
                                            />
                                        </div>
                                    </div>
                                )}
                                {this.hasRestrictions && 
                                    <div className={style.rowItem}>
                                        <div className={style.singleItem}>
                                            <label><I18n>weight</I18n></label>
                                            <InputDark 
                                                required={true} 
                                                type='number' 
                                                min="0" 
                                                name='weight' 
                                                question={`${I18n.t("weight")} (${this.weightUnit})`} 
                                                initialValue={''}
                                            />
                                        </div>
                                    </div>
                                    
                                }
                                <div className={style.rowItem}>
                                    <div className={ this.hasRestrictions ? style.item : style.singleItem}>
                                        {this.hasRestrictions &&
                                            <label><I18n>species</I18n></label>
                                        }
                                        <SelectDark 
                                            required={true} 
                                            data={this.classifications} 
                                            name='classificationID' 
                                            placeholder={I18n.t("species")} 
                                            value={''} 
                                            style={{marginBottom: '10px'}}
                                        />
                                    </div>
                               
                                    {this.hasRestrictions && 
                                         <div className={style.item}>
                                            <label><I18n>gender</I18n></label>
                                            <SelectDark 
                                                required={true} 
                                                data={this.genders} 
                                                name='genderID' 
                                                placeholder={I18n.t("gender")} 
                                                value={''} 
                                                style={{marginBottom: '10px'}}
                                            />
                                        </div>
                                    }
                                </div>
                                <div class={style.newPatientButtonContainer}>
                                    {this.patientsToCreate == 0 &&
                                        <Button onClick={this.handleNewPatientCancel}>Cancel</Button>
                                    }
                                    <Button >Submit</Button>
                                </div>
                            </Form>
                        </div>
                    </Tile>
                ):(
                    <Tile class={style.newPatientContainer}>
                        <div key="new-patient-prompt">
                            <Button  class={style.newPatient} onClick={this.handleNewPatient}>+ <I18n>addNewPet</I18n></Button>
                        </div>
                    </Tile>
                )}
            </Container>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PatientSelect/PatientSelectVertical.js